{{runChangeDetection}}
<!-- Default Page -->
<!--{{Service._openChatId}}{{isMobile}}---{{Service.isLoadedProfile}}___{{Service.arProfile | json}}-->
<ng-template #addAccountRef>
  <div *ngIf="allMessengersService.getServicesFilter('isAuth', false)?.length > 0" class="carousel-cell mb-2 px-0">
    <div (click)="interfaceService.addAccount(Service)" class="avatar avatar-lg pointer">
      <div
        class="avatar-icon text-primary bg-secondary effectMouse"
        (mousemove)="allService.effectMouseMove($event)"
      >
        <div class="d-flex w-100 align-items-center justify-content-center">
          <i-feather name="plus-circle" class="icon-lg"></i-feather>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #profile>
  <div
    (click)="interfaceService.showMobileHome = false"
    *ngIf="Service && !Service?.openChatId"
    [class.showMobile]="interfaceService._showMobileHome"
    class="chat flex-column justify-content-center text-center d-none d-md-flex showEffectXs"
  >
    <div *ngIf="Service.isLoadedProfile || !Service.isAuth; else loadProfile" class="container-xxl px-md-5">
      <div class="row mb-3 justify-content-center">
        <ng-template [ngIf]="allService.serviceType !== 'all' && Service.isAuth" [ngIfElse]="authBlock">
          <app-avatar
            [Service]="Service"
            [id]="Service.arProfile?.id"
            [class.avatar-online]="true"
            [type]="'private'"
            [avatar]="Service.arProfile?.avatar"
            [avatarFileId]="Service.arProfile.avatar_file_id"
            [avatarFileUniqueId]="Service.arProfile.avatar_file_unique_id"
            [force]="true"
            class="avatar avatar-lg mr-5"
          ></app-avatar>
        </ng-template>
        <ng-template #authBlock>
          <div class="col-auto mb-2 px-0">
            <carousel [arrows]="allMessengersService.getServicesFilter('isAuth', true)?.length > 4" [style.width.px]="sliderWidth" [height]="90" [cellsToShow]="countShowSlider">
              <ng-container *ngIf="Service.type !== 'fellowdesk'">
                <ng-template [ngTemplateOutlet]="addAccountRef"></ng-template>
              </ng-container>
              <div *ngFor="let service of allMessengersService.getServicesFilter('isAuth', true); let i = index" class="carousel-cell">
                <div (click)="clickService(service?.type)" class="pointer position-relative text-reset text-center">
                  <app-avatar
                    [Service]="service"
                    [id]="service.arProfile?.id"
                    [type]="'private'"
                    [avatar]="service.arProfile?.avatar"
                    [avatarFileId]="service.arProfile.avatar_file_id"
                    [avatarFileUniqueId]="service.arProfile.avatar_file_unique_id"
                    class="avatar avatar-lg"
                  >
                    <div *ngIf="service?.type">
                      <img
                        loading="lazy"
                        class="avatar-type avatar-type-lg pl-2 {{service?.type}} text-center"
                        width="30"
                        height="30"
                        src="/assets/icons/socials/{{ service?.type | fixType }}.svg"
                      />
                    </div>
                  </app-avatar>
                  <small
                    [style.max-width.px]="80"
                    class="text-muted text-truncate d-block"
                    [innerHTML]="service.arProfile?.name?.first | replaceEmojis: 'facebook':20:64"
                  ></small>
                </div>
              </div>
            </carousel>
          </div>
        </ng-template>
      </div>

      <h5>
        Приветствую тебя<span
        *ngIf="allService.serviceType !== 'all' && Service.isAuth"
        [innerHTML]="' ' + Service.arProfile?.name?.first | replaceEmojis: 'facebook':20:64"
      ></span
      >!
      </h5>
      <p *ngIf="Service.isAuth && !interfaceService.isTelesellerDomain">
        Выбери чат, или
        <a class="font-weight-bold pointer" (click)="createChat()">создайте беседу</a>, чтобы начать обмен
        сообщениями.
      </p>
      <div *ngIf="interfaceService.isTelesellerDomain && !interfaceService.isLeadsDomain">
        <button class="btn btn-primary mb-3" (click)="senderService.openSenderChat()">Создать рассылку</button>
        <div></div>
        <button class="btn btn-link"  (click)="toursService.startTour$.next(0)">Виртуальный помощник</button>
      </div>
    </div>
    <ng-template #loadProfile>
      <div class="container-xxl">
        <ng-template [ngTemplateOutlet]="addAccountRef"></ng-template>
        <div class="mt-4 mb-3 pb-3">
          <div class="loader-line"></div>
        </div>
      </div>
    </ng-template>
  </div>
</ng-template>

<!-- Chat -->
<!--|| (allService._openChatId && allService.serviceType == 'all')-->
<!--allService = {{allService.serviceType}}&#45;&#45;{{allService._openChatId}} |||
allMessengersService {{allMessengersService.Service.type}}&#45;&#45;{{allMessengersService.Service._openChatId}}-->
<div
  *ngIf="Service?.openChatId; else profile"
  [dropzone]="dropzoneConfig"
  (init)="onUploadInit($event)"
  (removedFile)="onRemovedFile($event)"
  (addedFile)="onAddedFile($event)"
  (sending)="onSending($event)"
  (queueComplete)="onQueueComplete($event)"
  (error)="onUploadError($event)"
  (success)="onUploadSuccess($event)"
  #dropzoneForm
  [class.has-selected-message]="arSelectMessages?.length > 0"
  [class.has-player]="musicPlayerService.playerData.open"
  class="chat"
>
  <!-- Chat: body -->
  <div class="chat-body" [class.hidden]="interfaceService.showDetailInfo && isMobile">
    <!-- Chat: Header -->
    <div
      (click)="interfaceService.showTabsInput$.next(false)"
      class="chat-header border-bottom py-2 py-lg-3 px-lg-4 px-xl-8"
    >
      <div class="container-xxl">
        <div
          *ngIf="arSelectMessages?.length == 0; else messagesPanel"
          class="row flex-nowrap justify-content-between align-items-center"
        >
          <!-- Close chat(mobile) -->
          <div class="col-auto d-md-none pl-0 pr-3">
            <ul class="list-inline mb-0">
              <li class="list-inline-item">
                <a (click)="closeChat()" class="py-4 pl-0 pr-2 btn btn-link text-muted btn btn-link" data-chat="open">
                  <i-feather name="chevron-left" class="icon-md"></i-feather>
                </a>
              </li>
            </ul>
          </div>
          <!-- Chat photo -->
          <div *ngIf="Service.openChat?.id" class="col-7 col-md-7 col-lg-6 col-xl-5 px-0 px-md-3">
            <div
              (click)="openDetailChat()"
              class="media pointer"
            >
              <app-avatar
                *ngIf="Service?.openChat?.isSelf; else elseAvatar"
                [id]="Service.openChatId"
                [type]="'self'"
                class="avatar mr-5"
              ></app-avatar>
              <ng-template #elseAvatar>
                <app-avatar
                  [Service]="Service"
                  [id]="Service.openChatId"
                  [class.avatar-online]="Service.openChat?.online"
                  [type]="Service.openChat?.type"
                  [avatar]="Service.openChat?.avatar"
                  [avatarFileId]="Service.openChat.avatar_file_id"
                  [avatarFileUniqueId]="Service.openChat.avatar_file_unique_id"
                  [force]="true"
                  class="avatar avatar-sm mr-5"
                >
                  <div
                    *ngIf="allService.serviceType === 'all' && Service.openChat?.service_type && Service.openChat?.service_type !== 'sender' && Service.openChat?.service_type !== 'fellowdesk'">
                   <span
                     class="chat-service-type avatar-type">
                      <img
                        loading="lazy"
                        class="title-type"
                        width="30"
                        height="30"
                        title="Номер аккаунта"
                        src="/assets/icons/socials/{{ Service.openChat?.service_type | fixType }}-empty.svg"
                        alt=""/>
                      <i>{{ Service.openChat?.service_type | serviceNumber }}</i>
                    </span>
                  </div>
                </app-avatar>
              </ng-template>
              <div class="media-body align-self-center text-truncate">
                <h6 [class.hidden]="!isLoaded" class="text-truncate mb-n1">
                      <span
                        [innerHTML]="interfaceService.getChatTitle(Service.openChat) | replaceEmojis: 'facebook':20:64"
                      ></span>
                  <i-feather
                    placement="left"
                    tooltip="Без&nbsp;звука"
                    *ngIf="Service.openChat?.mute_until > 0"
                    name="volume-x"
                    class="chat-muted text-muted mr-3"
                  ></i-feather>
                </h6>
                <ng-template #elseName></ng-template>
                <ng-template
                  [ngIf]="!Service.loadHistoryError && !allMessengersService.getConnectList().includes(Service.name)"
                  [ngIfElse]="errorConnect"
                >
                  <div class="text-primary" *ngIf="arTyping?.length > 0; else elseTitle">
                    <ng-template [ngIf]="Service.openChat.type !== 'private'">
                      <span *ngFor="let user of arTyping">{{ user?.name?.first || user?.name?.last }} </span>
                    </ng-template>
                    печатает<span class="typing-dots"><span>.</span><span>.</span><span>.</span></span>
                  </div>
                  <ng-template #elseTitle>
                    <app-text-user-online
                      [last_seen]="Service.openChat.last_seen"
                      [online]="Service.openChat?.online"
                      *ngIf="Service.openChat?.type === 'private' && !Service.openChat?.isSelf"
                    ></app-text-user-online>
                    <small *ngIf="Service.openChat?.members_count" class="text-muted">
                      {{appService.declOfNum(Service.openChat?.members_count, ['# участник', '# участника', '# участников'])}}
                    </small>
                  </ng-template>
                </ng-template>
                <ng-template #errorConnect>
                  <small class="text-danger">{{ Service.loadHistoryError ? 'Ошибка' : 'Соединение...' }}</small>
                </ng-template>
              </div>
            </div>
          </div>
          <div
            *ngIf="Service.type === 'sender' && (senderService.account$ | async)?.id"

            class="pointer col-auto d-xl-block text-right"
          >
            <a target="_blank" href="https://admin.teleseller.ru/builder/admin_panel_3344/prod/resources/django_nm6o/models/sender_accountstokens/queries/get"
               *ngIf="senderService.isAdmin()"
               class="btn btn-sm nav-link text-muted pl-0 pr-3"><i-feather name="database" class="icon-md"></i-feather></a>
            <button
              *ngIf="senderService.isAdmin()"
              (click)="toggleGrafana()"
              class="btn btn-sm nav-link text-muted px-0 pr-3"
            >
              <i-feather name="cpu" class="icon-md"></i-feather>
            </button>
            <small (click)="modalService.openModal('ModalAddBalanceComponent')" class="text-muted mr-3 align-middle d-none d-md-inline">#{{(senderService.account$ | async)?.id}}</small>
            <div
              (click)="modalService.openModal('ModalAddBalanceComponent')"
              class="sender-balance badge badge-{{senderService.balanceColor}}">{{(senderService.account$ | async)?.balance | number}}
              ₽ |
              <i-feather name="plus" class="icon-md"></i-feather>
            </div>

          </div>
          <div *ngIf="Service.type !== 'sender'" class="col-4 col-md-5 col-lg-6 col-xl-7">
            <div class="row justify-content-end align-items-center">

              <div
                *ngIf="allService.arPinnedMessages?.length > 0 && !interfaceService.showSidebar"
                class="col-5 col-xl-7 d-none d-xl-block"
              >
                <app-message-pinned [Service]="Service"></app-message-pinned>
              </div>

              <!-- Chat toolbar -->

              <div
                [style.min-width.px]="130"
                *ngIf="allService._openChatId && Service.type !== 'sender'"
                class="col-auto align-self-end text-right px-0 px-md-3"
              >
                <ul class="nav justify-content-end">
                  <li *ngIf="Service.openChat?.type !== 'channel' && Service.openChat?.type !== 'bot' && Service?.type !== 'fellowdesk'"
                      class="nav-item list-inline-item mr-3">
                    <button
                      (click)="callService.startCall(Service.openChat, Service, 'video')"
                      class="btn btn-sm nav-link text-muted px-3"
                    >
                      <i-feather name="video" class="icon-md"></i-feather>
                    </button>
                  </li>

                  <li class="nav-item list-inline-item d-none d-md-block mr-0">
                    <button
                      class="btn btn-sm nav-link text-muted px-3"
                      (click)="interfaceService.showDetail$.next(Service.openChatId)"
                      placement="left"
                      tooltip="Детали чата"
                    >
                      <i-feather name="layout" class="icon-md icon-r-horizontal"></i-feather>
                    </button>
                  </li>
                  <!-- Mobile nav -->
                  <li class="nav-item list-inline-item d-block">
                    <div class="btn-group" dropdown placement="bottom">
                      <button dropdownToggle class="btn btn-sm nav-link text-muted pl-0 pr-3">
                        <i-feather name="more-vertical" class="icon-md"></i-feather>
                      </button>
                      <ul
                        [style.margin-left]="'-250px'"
                        id="dropdown-animated"
                        *dropdownMenu
                        class="dropdown-menu"
                        role="menu"
                        aria-labelledby="button-animated"
                      >
                        <li *ngIf="Service?.type !== 'fellowdesk'" (click)="searchToggle()">
                          <a href="javascript:void(0)" class="dropdown-item">
                            Поиск
                            <i-feather name="search"></i-feather>
                          </a>
                        </li>
                        <li (click)="interfaceService.showDetail$.next(Service.openChatId)">
                          <a href="javascript:void(0)" class="dropdown-item">
                            <ng-template [ngIf]="Service.openChat?.type !== 'private'" [ngIfElse]="privateProfileLink">
                              Информация о чате
                              <i-feather name="layout" class="icon-r-horizontal"></i-feather>
                            </ng-template>
                            <ng-template #privateProfileLink>
                              Показать профиль
                              <i-feather name="user"></i-feather>
                            </ng-template>
                          </a>
                        </li>

                        <li
                          *ngIf="Service?.type !== 'fellowdesk'"
                          (click)="
                            modalService.openModal('ModalNotifySettingsComponent', {
                              Service: Service,
                              chat: Service.openChat
                            })
                          "
                        >
                          <a href="javascript:void(0)" class="dropdown-item">
                            Настроить уведомления
                            <i-feather name="bell"></i-feather>
                          </a>
                        </li>
                        <ng-template [ngIf]="Service.openChat?.type !== 'private'">
                          <li
                            (click)="
                              modalService.openModal('ModalAddChatMemberComponent', {
                                Service: Service,
                                chatId: Service.openChatId
                              })
                            "
                          >
                            <a href="javascript:void(0)" class="dropdown-item">
                              Пригласить собеседника
                              <i-feather name="user-plus"></i-feather>
                            </a>
                          </li>
                          <li (click)="allMessengersService.leaveChat(Service.openChat, false, Service).subscribe()">
                            <a href="javascript:void(0)" class="dropdown-item">
                              Покинуть чат
                              <i-feather name="log-out"></i-feather>
                            </a>
                          </li>
                        </ng-template>
                        <li *ngIf="Service?.type !== 'fellowdesk'" (click)="allMessengersService.leaveChat(Service.openChat, true, Service).subscribe()">
                          <a href="javascript:void(0)" class="dropdown-item">
                            &nbsp;Удалить чат
                            <i-feather name="trash-2" class="text-danger"></i-feather>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <!-- Mobile nav -->
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- .row -->

        <ng-template #messagesPanel>
          <div class="row justify-content-between align-items-center">
            <div class="col-auto font-weight-bold">
              <button (click)="clearSelectMessages()" class="nav-link btn btn-link pointer p-0">
                {{ arSelectMessages?.length | declination: ['cообщение', 'cообщения', 'cообщений'] }}
                <i-feather name="x" class="icon-lg pointer"></i-feather>
              </button>
            </div>
            <div class="col-auto px-md-3">
              <button
                (click)="deleteSelectMessages()"
                placement="left"
                tooltip="Удалить"
                class="btn btn-sm btn-link mr-5"
                type="button"
              >
                <i-feather name="trash-2" class="text-danger icon-md"></i-feather>
              </button>
              <ng-template [ngIf]="!isMobile" [ngIfElse]="mobileMessagesPanel">
                <button class="btn btn-sm btn-primary mr-5 hidden" type="button">
                  <i-feather name="corner-up-left"></i-feather>&nbsp;Ответить
                </button>
                <button (click)="forwardSelectMessages()" class="btn btn-sm btn-primary" type="button">
                  <i-feather name="share"></i-feather>&nbsp;Переслать
                </button>
              </ng-template>
              <ng-template #mobileMessagesPanel>
                <button class="btn btn-sm btn-link mr-5 hidden" type="button">
                  <i-feather name="corner-up-left" class="text-muted icon-md"></i-feather>
                </button>
                <button (click)="forwardSelectMessages()" class="btn btn-sm btn-link" type="button">
                  <i-feather name="share" class="text-muted icon-md"></i-feather>
                </button>
              </ng-template>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="d-none d-md-block">
      <ng-content></ng-content>
    </div>
    <!-- Chat: Header -->
    <div class="grafana-wrap" *ngIf="interfaceService.openGrafana$ | async">
      <iframe class="grafana" src="https://messenger.teleseller.ru:5555/d/f557807c-be86-4789-a7cb-ef2bc744f2b2/telesellershare?orgId=1&from=now-24h&to=now&theme=light&refresh=1m"></iframe>
    </div>

    <!-- Chat: Content-->
    <app-messages-scroll
      *ngIf="!(interfaceService.openGrafana$ | async)"
      (onEditMessage)="editMessageText($event)"
      (onReplyMessage)="replyMessageText($event)"
      (onToggleMessage)="toggleMessage($event)"
      (onChangeLoaded)="isLoaded = $event"
      class="chat-content d-flex flex-column position-relative"
      [Service]="Service"
    >
    </app-messages-scroll>
    <!-- Chat: Content -->
    <!-- Chat: DropzoneJS container -->
    <div class="chat-files px-md-4 px-lg-8">
      <div class="container-xxl">
        <div #dropzonePreviews class="dropzone-previews-js scroll-bottom-chat form-row py-4"></div>
      </div>
    </div>
    <!-- Chat: DropzoneJS container -->
    <!-- Chat: Footer -->
    <div
      *ngIf="Service.editMessage && Service.editMessage.text && Service.type !== 'sender'"
      class="opacity-block chat-edit-block border-top py-4 py-lg-6 px-lg-8"
    >
      <div class="container-xxl">
        <div class="form-row">
          <div class="col">
            Редактирование
            <a class="font-weight-bold pointer" (click)="scrollToMessage(Service.editMessage)">сообщения</a>
          </div>
          <div class="col-auto">
            <button (click)="editCancel()" class="nav-link btn btn-link pointer p-0">
              <i-feather name="x" class="icon-lg pointer"></i-feather>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ng-template [ngIf]="Service.replyMessage">
      <div
        *ngIf="Service.replyMessage?.text || Service.replyMessage?.text_list"
        class="opacity-block chat-reply-block border-top py-4 py-lg-6 px-lg-8"
      >
        <div class="container-xxl">
          <div class="form-row ">
            <div class="col-auto">
              <i-feather name="corner-up-left" class="icon-lg pointer invert"></i-feather>
            </div>
            <div class="col scroll-bottom-chat">
              <h6 class="pointer pointer m-0">
                <ng-template [ngIf]="Service?.replyMessage?.out" [ngIfElse]="replyName">Вы</ng-template>
                <ng-template #replyName
                ><span
                  (click)="openDetailInfo(Service.replyMessage)"
                  [ngStyle]="{ color: Service.replyMessage.color }"
                  [innerHTML]="
                      Service.replyMessage?.name?.first + ' ' + Service.replyMessage?.name?.last
                        | replaceEmojis: 'facebook':20:64
                    "
                ></span
                ></ng-template>
              </h6>
              <div
                [innerHTML]="
                  Service.replyMessage.text || Service.replyMessage.text_list | replaceEmojis: 'facebook':20:64
                "
              ></div>
            </div>
            <div class="col-auto">
              <a (click)="cancelReply()" class="nav-link pointer p-0">
                <i-feather name="x" class="icon-lg pointer invert"></i-feather>
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="Service.forwardMessage">
      <div
        *ngIf="Service.forwardMessage?.text || Service.forwardMessage?.text_list"
        class="opacity-block chat-forward-block border-top py-4 py-lg-6 px-lg-8"
      >
        <div class="container-xxl">
          <div class="form-row ">
            <div class="col-auto">
              <i-feather name="corner-up-left" class="icon-lg pointer invert"></i-feather>
            </div>
            <div class="col scroll-bottom-chat">
              <h6 class="pointer pointer m-0">
                <ng-template [ngIf]="Service?.forwardMessage?.out" [ngIfElse]="replyName">Вы</ng-template>
                <ng-template #replyName
                ><span
                  (click)="openDetailInfo(Service.forwardMessage)"
                  [ngStyle]="{ color: Service.forwardMessage.color }"
                  [innerHTML]="
                      Service.forwardMessage?.name?.first + ' ' + Service.forwardMessage?.name?.last
                        | replaceEmojis: 'facebook':20:64
                    "
                ></span
                ></ng-template>
              </h6>
              <div
                [innerHTML]="
                  Service.forwardMessage.text || Service.forwardMessage.text_list | replaceEmojis: 'facebook':20:64
                "
              ></div>
            </div>
            <div class="col-auto">
              <a (click)="cancelForward()" class="nav-link pointer p-0">
                <i-feather name="x" class="icon-lg pointer invert"></i-feather>
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="resultSpellCheck?.length > 0 && spellCheckText && !allService.isTouchDevice && !interfaceService.isTelesellerDomain">
      <div class="opacity-block chat-edit-block border-top py-4 py-lg-6 px-lg-8">
        <div class="container-xxl">
          <div class="form-row">
            <div class="col-auto">
              <i-feather name="edit" class="icon-lg pointer invert"></i-feather>
            </div>
            <div class="col scroll-bottom-chat">
              <h6 class="pointer pointer m-0 text-muted font-weight-bold mb-2">
                Клик по словам для исправления ошибок или
                <span (click)="replaceAllSpell()" class="btn-spell bg-primary">исправить все</span>
              </h6>
              <div
                class="spellList no-invert"
                (click)="clickSpellItem($event)"
                [innerHTML]="spellCheckText | replaceEmojis: 'facebook':20:64"
              ></div>
            </div>
            <div class="col-auto">
              <button (click)="cancelSpellCheck()" class="nav-link btn btn-link pointer p-0">
                <i-feather name="x" class="icon-lg pointer"></i-feather>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="arSearchMembers?.length > 0">
      <div class="opacity-block chat-edit-block border-top py-4 py-lg-6 px-lg-4">
        <div class="">
          <ul class="list-group scroll-bottom-chat">
            <li
              [class.active]="selectUsernameIndex == i"
              (click)="selectMember(member)"
              *ngFor="let member of arSearchMembers; let i = index"
              class="list-group-item pointer"
            >
              <div class="form-row">
                <div class="col-auto">
                  <app-avatar
                    [Service]="Service"
                    [id]="member?.id"
                    [class.avatar-online]="member?.online"
                    [type]="member?.type"
                    [avatar]="member?.avatar"
                    [avatarFileId]="member?.avatar_file_id"
                    [avatarFileUniqueId]="member?.avatar_file_unique_id"
                    class="avatar avatar-xs"
                  ></app-avatar>
                </div>
                <div class="col-auto">
                  <span
                    [innerHTML]="member?.name?.first + ' ' + member?.name?.last | replaceEmojis: 'facebook':20:64"
                  ></span>
                </div>
                <div *ngIf="member?.username" class="col-auto text-muted">@{{ member?.username }}</div>
                <div *ngIf="member?.phone_number" class="col-auto text-muted d-none d-md-block">
                  {{ member?.phone_number }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ng-template>
    <div class="container-xxl footer-voice-block">
      <app-voice
        *ngIf="isRecord"
        (onSendVoice)="addMessage($event)"
        (onClose)="onCloseVoice()"
        [Service]="Service"
      ></app-voice>
    </div>
    <div id="sender-add-config" *ngIf="senderService.senderAddForm && Service.openChatId === 'sender'"
         class="footer-sender-block opacity-block border-top py-3 py-lg-4">
      <div class="container-xxl">
        <div class="form-row">
          <div class="col">
            <h5 class="text-muted sender-add__title">
              <span [ngSwitch]="senderService.senderType">
                <ng-template [ngSwitchCase]="0">
                  <i-feather name="message-square" class="text-black"></i-feather>
                </ng-template>
                <ng-template [ngSwitchCase]="1">
                  <i-feather name="trending-up" class="text-black"></i-feather>
                </ng-template>
                <ng-template [ngSwitchCase]="2">
                  <i-feather name="media" class="text-black mr-3"></i-feather>
                </ng-template>
                <ng-template [ngSwitchCase]="3">
                  <i-feather name="cpu" class="text-black"></i-feather>
                </ng-template>
              </span>
              {{Service.editMessage ? 'Изменеие' : 'Создание'}} рассылки
            </h5>
          </div>
          <div class="col-auto">
            <button (click)="closeSenderForm()" class="nav-link btn btn-link pointer p-0">
              <i-feather name="x" class="icon-lg pointer"></i-feather>
            </button>
          </div>
        </div>
        <app-add-form-sender></app-add-form-sender>
      </div>
    </div>
    <div
      [class.hidden]="isRecord || !allService.permissionsCheck('can_send_messages', Service) || (this.interfaceService.openGrafana$ | async)"
      class="chat-footer bg-secondary border-top py-3 py-lg-4 px-lg-8"
    >
      <div class="container-xxl">
        <form [class.disabled]="Service.disabledMessageTextarea" [formGroup]="FormMessage">
          <div class="form-row align-items-center">

            <div *ngIf="Service.type !== 'sender' && allMessengersService.arServicesAuthorized?.length > 1"
                 class="col-auto pl-0 pr-3 d-none d-lg-block">
              <app-avatar
                [Service]="Service"
                [id]="Service.arProfile?.id"
                [type]="'private'"
                [force]="true"
                [avatar]="Service.arProfile?.avatar"
                [avatarFileId]="Service.arProfile?.avatar_file_id"
                [avatarFileUniqueId]="Service.arProfile?.avatar_file_unique_id"
                placement="top" [tooltip]="Service.arProfile?.name?.first + ' ' + Service.arProfile?.name?.last"
                class="avatar avatar-sm"
              >
              </app-avatar>
            </div>
            <div class="col pl-0">
              <div (click)="messageInputClick()" [class.message-input-animate]="interfaceService.isMessageInputAnimate && interfaceService.isTelesellerDomain"
                   id="message-form" class="input-group bg-white rounded-lg position-relative">

                <ng-template [ngIf]="interfaceService.messageTextareaType === 'editor'" [ngIfElse]="textareaEditor">
                  <app-message-editor
                    (onSubmit)="enterMessage($event)"
                    (onFocus)="textareaFocus()"
                    (onKeyUp)="textareaKeyUp($event)"
                    (onInput)="textareaInput($event)"
                    [Service]="Service"
                    [placeholder]="Service?.messageInputText || 'Новое сообщение'"
                  ></app-message-editor>
                </ng-template>
                <ng-template #textareaEditor>
                  <div
                    [style.height.px]="messageText.offsetHeight - 5"
                    *ngIf="isPreviewTextarea"
                    [innerHTML]="Service.message | replaceEmojis: 'facebook':16:64"
                    class="preview-textarea"
                  ></div>
                  <textarea
                    (mouseenter)="textareaMouseenter()"
                    (mouseout)="textareaMouseout()"
                    (click)="setTextAreaPosition()"
                    (keyup)="textareaKeyUp($event)"
                    (paste)="textareaPasted($event)"
                    (input)="textareaInput($event)"
                    (keyup.enter)="textareaEnter($event)"
                    (keydown.enter)="$event.preventDefault()"
                    (focus)="textareaFocus()"
                    (focusout)="textareaFocusout()"
                    autosize
                    [attr.autofocus]="!isMobile"
                    #messageText
                    [(ngModel)]="Service.message"
                    formControlName="text"
                    class="invert-filter form-control bg-transparent border-0"
                    [class.opacity-0]="isPreviewTextarea"
                    placeholder="{{Service?.messageInputText || 'Новое сообщение'}}"
                    rows="1"
                  ></textarea>
                </ng-template>
                <!-- Emoji button -->
                <div *ngIf="!allService.isTouchDevice || !isMobile" class="input-group-append">
                  <button
                    tooltip="Смайлы"
                    (click)="interfaceService.showTabsInput$.next('toggle')"
                    class="btn btn-secondary btn-minimal bg-transparent border-0 px-2"
                    type="button"
                  >
                    <i-feather name="smile" class="icon-md"></i-feather>
                  </button>
                </div>
                <!-- Upload button -->
                <div *ngIf="allService.permissionsCheck('can_send_media_messages', Service)"
                     class="input-group-append">
                  <button
                    #fileSelect
                    tooltip="Прикрепить файл, нажмите или перенесите мышкой файл в окно"
                    id="chat-upload-btn-1"
                    class="btn btn-secondary btn-minimal bg-transparent border-0 dropzone-button-js px-3"
                    type="button"
                  >
                    <i-feather name="paperclip" class="icon-md"></i-feather>
                  </button>
                </div>
              </div>
            </div>
            <!-- Submit button -->
            <div class="col-auto px-0 px-lg-2 pr-lg-0" [class.pr-md-10]="!interfaceService.showTabsInput">
              <ng-template [ngIf]="(Service.type === 'sender') && !Service.editMessage" [ngIfElse]="defaultSendButton">
                <button
                  (click)="sendMessage($event)"
                  [class.effectPulse]="senderService.validSenderForm"
                  class="btn btn-ico btn-primary rounded-circle position-relative"
                  type="submit"
                  [disabled]="senderService.isSending"
                  [class.btn-circle-load]="senderService.isSending"
                >
                  <i-feather name="send" class="icon-md"></i-feather>
                  <textarea *ngIf="allService.isTouchDevice" id="fakeSendBtn"></textarea>
                  <ng-template [ngTemplateOutlet]="svg"></ng-template>
                </button>
              </ng-template>
              <ng-template #defaultSendButton>
                <button
                  (click)="sendMessage($event)"
                  *ngIf="
                  (Service.message?.length !== 0 || arFilesCount !== 0 || uploadFile) && !Service.editMessage || (Service.type === 'sender' && !Service.editMessage);
                  else recordBtn
                "
                  class="btn btn-ico btn-primary rounded-circle position-relative"
                  type="submit"
                  [class.btn-circle-load]="uploadFile || isSending"
                  [disabled]="uploadFile || isSending || Service.message?.length == 0"
                >
                  <i-feather name="send" class="icon-md"></i-feather>
                  <textarea *ngIf="allService.isTouchDevice" id="fakeSendBtn"></textarea>
                  <ng-template [ngTemplateOutlet]="svg"></ng-template>
                </button>
              </ng-template>
              <ng-template #recordBtn>
                <button
                  *ngIf="!Service.editMessage && Service.type !== 'fellowdesk'"
                  (click)="startRecord()"
                  class="btn btn-ico btn-danger rounded-circle"
                  type="button"
                >
                  <i-feather name="mic" class="icon-md"></i-feather>
                </button>
              </ng-template>
            </div>
            <!-- Save button -->
            <div *ngIf="Service.editMessage" class="col-auto px-0 px-lg-2">
              <button
                [disabled]="saveMessageDisabled()"
                (click)="saveMessage()"
                class="btn btn-ico btn-primary rounded-circle"
                type="button"
              >
                <i-feather name="save" class="icon-md"></i-feather>
              </button>
            </div>
          </div>
          <small *ngIf="Service.type === 'sender' && Service.message?.length > 1024 && arFilesCount > 0">
            <i-feather name="info" class="mr-2 text-info"></i-feather>
            Текст расылки будет отправлен вторым сообщением после файла, так как текст длинее 1024 символов.
          </small>
        </form>
      </div>
    </div>
    <!-- Chat: Footer -->
  </div>
  <!-- Chat: body -->
  <div
    class="chat-sidebar shadow-theme"
    [class.chat-tabs-input]="interfaceService.showTabsInput"
    [class.chat-sidebar-visible]="interfaceService.showSidebar"
  >
    <app-chat-media-right
      *ngIf="interfaceService.initTabsInput"
      [Service]="Service"
      [class.hidden]="!interfaceService.showTabsInput && allService.permissionsCheck('can_send_messages', Service)"
    >
    </app-chat-media-right>
    <!-- Chat Details -->
    <app-chat-detail
      *ngIf="interfaceService.showDetailInfo"
      [Service]="Service"
      [id]="showDetailInfoId"
    ></app-chat-detail>
    <!-- Chat Details -->
  </div>
</div>
<!-- Chat -->

<!-- DropzoneJS: Template -->
<div #dropzoneTemplate id="dropzone-template-js" class="hidden">
  <div class="dropzone-item col-auto my-3">
    <div class="card card-file position-relative">
      <div class="progressbar-wrapper">
        <div data-dz-uploadprogress class="progressbar">
          <div class="stylization"></div>
        </div>
      </div>
      <div class="card-body p-3">
        <div class="media align-items-center">
          <div class="dropzone-file-preview">
            <div class="avatar avatar rounded bg-secondary text-basic-inverse d-block mr-5">
              <i-feather class="icon-lg" name="paperclip"></i-feather>
            </div>
          </div>
          <div class="dz-success-mark">
            <i-feather name="check"></i-feather>
          </div>
          <div class="dz-error-mark">
            <i-feather class="icon-lg" name="x"></i-feather>
          </div>
          <div class="dz-error-message"><span data-dz-errormessage></span></div>
          <div class="dropzone-image-preview">
            <div class="avatar avatar mr-5">
              <img loading="lazy" src="#" class="avatar-img rounded invert" data-dz-thumbnail="" alt=""/>
            </div>
          </div>
          <div class="media-body overflow-hidden">
            <h6 class="text-truncate small mb-0" data-dz-name></h6>
            <p class="extra-small" data-dz-size></p>
          </div>
          <div class="ml-5">
            <a href="#" class="btn btn-sm btn-white text-decoration-none" data-dz-remove>
              <i-feather name="x" class="pointer"></i-feather>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- DropzoneJS: Template -->

<ng-template #deleteModalContent>
  <label nz-checkbox [(ngModel)]="Service.isDeleteAllMessage">Удалить для всех</label>
</ng-template>


<ng-template #svg>
  <svg
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    xmlns:xlink="https://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    style="display: none"
  >
    <symbol id="wave">
      <path
        d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z"
      ></path>
      <path
        d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z"
      ></path>
      <path
        d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z"
      ></path>
      <path
        d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z"
      ></path>
    </symbol>
  </svg>
</ng-template>
